import { render, staticRenderFns } from "./ConfirmacaoAtendimento.vue?vue&type=template&id=4a4054ac&scoped=true&"
import script from "./ConfirmacaoAtendimento.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ConfirmacaoAtendimento.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4054ac",
  null
  
)

export default component.exports